import { render, staticRenderFns } from "./tableIBC.vue?vue&type=template&id=9a04073a&scoped=true"
import script from "./tableIBC.vue?vue&type=script&lang=js"
export * from "./tableIBC.vue?vue&type=script&lang=js"
import style0 from "./tableIBC.vue?vue&type=style&index=0&id=9a04073a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a04073a",
  null
  
)

export default component.exports